Object.defineProperty(exports, "__esModule", {
    value: true
});
var _async_to_generator = require("@swc/helpers/_/_async_to_generator");
var _object_spread = require("@swc/helpers/_/_object_spread");
var _object_spread_props = require("@swc/helpers/_/_object_spread_props");
var require_logger = require('./logger.cjs');
var require_global = require('../global.cjs');
var require_constant = require('../constant.cjs');
var _module_federation_sdk = require("@module-federation/sdk");
var _module_federation_error_codes = require("@module-federation/error-codes");
//#region src/utils/load.ts
var importCallback = ".then(callbacks[0]).catch(callbacks[1])";
function loadEsmEntry(_0) {
    return _async_to_generator._(function*(param) {
        var entry = param.entry, remoteEntryExports = param.remoteEntryExports;
        return new Promise((resolve, reject)=>{
            try {
                if (!remoteEntryExports) if (typeof FEDERATION_ALLOW_NEW_FUNCTION !== "undefined") new Function("callbacks", `import("${entry}")${importCallback}`)([
                    resolve,
                    reject
                ]);
                else import(/* webpackIgnore: true */ /* @vite-ignore */ entry).then(resolve).catch(reject);
                else resolve(remoteEntryExports);
            } catch (e) {
                require_logger.error(`Failed to load ESM entry from "${entry}". ${e instanceof Error ? e.message : String(e)}`);
            }
        });
    }).apply(this, arguments);
}
function loadSystemJsEntry(_0) {
    return _async_to_generator._(function*(param) {
        var entry = param.entry, remoteEntryExports = param.remoteEntryExports;
        return new Promise((resolve, reject)=>{
            try {
                if (!remoteEntryExports) if (typeof __system_context__ === "undefined") System.import(entry).then(resolve).catch(reject);
                else new Function("callbacks", `System.import("${entry}")${importCallback}`)([
                    resolve,
                    reject
                ]);
                else resolve(remoteEntryExports);
            } catch (e) {
                require_logger.error(`Failed to load SystemJS entry from "${entry}". ${e instanceof Error ? e.message : String(e)}`);
            }
        });
    }).apply(this, arguments);
}
function handleRemoteEntryLoaded(name, globalName, entry) {
    var _require_global_getRemoteEntryExports = require_global.getRemoteEntryExports(name, globalName), remoteEntryKey = _require_global_getRemoteEntryExports.remoteEntryKey, entryExports = _require_global_getRemoteEntryExports.entryExports;
    if (!entryExports) require_logger.error(_module_federation_error_codes.RUNTIME_001, _module_federation_error_codes.runtimeDescMap, {
        remoteName: name,
        remoteEntryUrl: entry,
        remoteEntryKey
    });
    return entryExports;
}
function loadEntryScript(_0) {
    return _async_to_generator._(function*(param) {
        var name = param.name, globalName = param.globalName, entry = param.entry, remoteInfo = param.remoteInfo, loaderHook = param.loaderHook, getEntryUrl = param.getEntryUrl;
        var _require_global_getRemoteEntryExports = require_global.getRemoteEntryExports(name, globalName), remoteEntryExports = _require_global_getRemoteEntryExports.entryExports;
        if (remoteEntryExports) return remoteEntryExports;
        var url = getEntryUrl ? getEntryUrl(entry) : entry;
        return (0, _module_federation_sdk.loadScript)(url, {
            attrs: {},
            createScriptHook: (url, attrs)=>{
                var res = loaderHook.lifecycle.createScript.emit({
                    url,
                    attrs,
                    remoteInfo
                });
                if (!res) return;
                if (res instanceof HTMLScriptElement) return res;
                if ("script" in res || "timeout" in res) return res;
            }
        }).then(()=>{
            return handleRemoteEntryLoaded(name, globalName, entry);
        }, (loadError)=>{
            var originalMsg = loadError instanceof Error ? loadError.message : String(loadError);
            require_logger.error(_module_federation_error_codes.RUNTIME_008, _module_federation_error_codes.runtimeDescMap, {
                remoteName: name,
                resourceUrl: url
            }, originalMsg);
        });
    }).apply(this, arguments);
}
function loadEntryDom(_0) {
    return _async_to_generator._(function*(param) {
        var remoteInfo = param.remoteInfo, remoteEntryExports = param.remoteEntryExports, loaderHook = param.loaderHook, getEntryUrl = param.getEntryUrl;
        var entry = remoteInfo.entry, globalName = remoteInfo.entryGlobalName, name = remoteInfo.name, type = remoteInfo.type;
        switch(type){
            case "esm":
            case "module":
                return loadEsmEntry({
                    entry,
                    remoteEntryExports
                });
            case "system":
                return loadSystemJsEntry({
                    entry,
                    remoteEntryExports
                });
            default:
                return loadEntryScript({
                    entry,
                    globalName,
                    name,
                    remoteInfo,
                    loaderHook,
                    getEntryUrl
                });
        }
    }).apply(this, arguments);
}
function loadEntryNode(_0) {
    return _async_to_generator._(function*(param) {
        var remoteInfo = param.remoteInfo, loaderHook = param.loaderHook;
        var entry = remoteInfo.entry, globalName = remoteInfo.entryGlobalName, name = remoteInfo.name, type = remoteInfo.type;
        var _require_global_getRemoteEntryExports = require_global.getRemoteEntryExports(name, globalName), remoteEntryExports = _require_global_getRemoteEntryExports.entryExports;
        if (remoteEntryExports) return remoteEntryExports;
        return (0, _module_federation_sdk.loadScriptNode)(entry, {
            attrs: {
                name,
                globalName,
                type
            },
            loaderHook: {
                createScriptHook: function createScriptHook(url) {
                    var attrs = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                    var res = loaderHook.lifecycle.createScript.emit({
                        url,
                        attrs,
                        remoteInfo
                    });
                    if (!res) return;
                    if ("url" in res) return res;
                }
            }
        }).then(()=>{
            return handleRemoteEntryLoaded(name, globalName, entry);
        }).catch((e)=>{
            require_logger.error(`Failed to load Node.js entry for remote "${name}" from "${entry}". ${e instanceof Error ? e.message : String(e)}`);
        });
    }).apply(this, arguments);
}
function getRemoteEntryUniqueKey(remoteInfo) {
    var entry = remoteInfo.entry, name = remoteInfo.name;
    return (0, _module_federation_sdk.composeKeyWithSeparator)(name, entry);
}
function getRemoteEntry(params) {
    return _async_to_generator._(function*() {
        var origin = params.origin, remoteEntryExports = params.remoteEntryExports, remoteInfo = params.remoteInfo, getEntryUrl = params.getEntryUrl, _params__inErrorHandling = params._inErrorHandling, _inErrorHandling = _params__inErrorHandling === void 0 ? false : _params__inErrorHandling;
        var uniqueKey = getRemoteEntryUniqueKey(remoteInfo);
        if (remoteEntryExports) return remoteEntryExports;
        if (!require_global.globalLoading[uniqueKey]) {
            var loadEntryHook = origin.remoteHandler.hooks.lifecycle.loadEntry;
            var loaderHook = origin.loaderHook;
            require_global.globalLoading[uniqueKey] = loadEntryHook.emit({
                loaderHook,
                remoteInfo,
                remoteEntryExports
            }).then((res)=>{
                if (res) return res;
                return (typeof ENV_TARGET !== "undefined" ? ENV_TARGET === "web" : _module_federation_sdk.isBrowserEnvValue) ? loadEntryDom({
                    remoteInfo,
                    remoteEntryExports,
                    loaderHook,
                    getEntryUrl
                }) : loadEntryNode({
                    remoteInfo,
                    loaderHook
                });
            }).catch((err)=>_async_to_generator._(function*() {
                    var uniqueKey = getRemoteEntryUniqueKey(remoteInfo);
                    var isScriptExecutionError = err instanceof Error && err.message.includes("ScriptExecutionError");
                    if (err instanceof Error && err.message.includes(_module_federation_error_codes.RUNTIME_008) && !isScriptExecutionError && !_inErrorHandling) {
                        var wrappedGetRemoteEntry = (params)=>{
                            return getRemoteEntry(_object_spread_props._(_object_spread._({}, params), {
                                _inErrorHandling: true
                            }));
                        };
                        var RemoteEntryExports = yield origin.loaderHook.lifecycle.loadEntryError.emit({
                            getRemoteEntry: wrappedGetRemoteEntry,
                            origin,
                            remoteInfo,
                            remoteEntryExports,
                            globalLoading: require_global.globalLoading,
                            uniqueKey
                        });
                        if (RemoteEntryExports) return RemoteEntryExports;
                    }
                    throw err;
                })());
        }
        return require_global.globalLoading[uniqueKey];
    })();
}
function getRemoteInfo(remote) {
    return _object_spread_props._(_object_spread._({}, remote), {
        entry: "entry" in remote ? remote.entry : "",
        type: remote.type || require_constant.DEFAULT_REMOTE_TYPE,
        entryGlobalName: remote.entryGlobalName || remote.name,
        shareScope: remote.shareScope || require_constant.DEFAULT_SCOPE
    });
}
//#endregion
exports.getRemoteEntry = getRemoteEntry;
exports.getRemoteEntryUniqueKey = getRemoteEntryUniqueKey;
exports.getRemoteInfo = getRemoteInfo; //# sourceMappingURL=load.cjs.map
